module.exports = __webpack_public_path__ + "img/analytics.310c5e7a.png";